import Vue from "vue";
import ActionCableVue from "actioncable-vue";

const actionCableProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const sameOriginActionCableUrl = `${actionCableProtocol}//${window.location.host}/cable`;

const opts = {
  debug: true,
  debugLevel: "error",
  connectionUrl: process.env.VUE_APP_ACTIONCABLE_URL || sameOriginActionCableUrl,
  connectImmediately: true,
};

Vue.use(ActionCableVue, opts);

export default ActionCableVue;
